import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Modal } from '@mui/material'
import tw from 'twin.macro'
import { FormikProps } from 'formik'
import { ModalHeader } from 'src/components/shared/ModalHeader'
import { CreateTeamRoleForm } from './create-team-role-form/CreateTeamRoleForm'
import { CreateTeamRoleFormValues } from './create-team-role-form/CreateTeamRoleForm.interface'
import { useDispatch } from 'react-redux'
import { FetchTeamPermissions } from 'src/constants/actionTypes'

interface Props {
  isCreateTeamRoleModalOpen: boolean
  closeCreateTeamRoleModal(): void
  refreshTeamRoles(): Promise<void>
}

export const CreateTeamRoleModal = ({
  isCreateTeamRoleModalOpen,
  closeCreateTeamRoleModal,
  refreshTeamRoles,
}: Props) => {
  const dispatch = useDispatch()

  const container = document.getElementById('root')

  const formRef = useRef<FormikProps<CreateTeamRoleFormValues> | null>(null)

  const [isLoading, setIsLoading] = useState(true)

  const fetchTeamPermissions = useCallback(() => {
    setIsLoading(true)

    try {
      dispatch(FetchTeamPermissions.request())
    } finally {
      setIsLoading(false)
    }
  }, [dispatch])

  useEffect(() => {
    fetchTeamPermissions()
  }, [fetchTeamPermissions])

  return (
    <Modal
      container={container}
      open={isCreateTeamRoleModalOpen}
      onClose={closeCreateTeamRoleModal}
      aria-labelledby="create-role-modal-title"
      aria-describedby="create-role-modal-description"
      css={tw`fixed inset-0 flex items-center justify-center`}
    >
      <div css={tw`w-[400px] h-[90vh] bg-white flex flex-col rounded-lg shadow-lg`}>
        <ModalHeader className={tw`h-11`} title="Create new role" showCloseButton={false} />
        <CreateTeamRoleForm
          closeCreateTeamRoleModal={closeCreateTeamRoleModal}
          innerRef={formRef}
          isLoading={isLoading}
          refreshTeamRoles={refreshTeamRoles}
          setIsLoading={setIsLoading}
        />
      </div>
    </Modal>
  )
}
